if (!customElements.get('series-lineup')) {
  customElements.define('series-lineup', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const track = this.querySelector('.s2-track');
      if (!track.querySelector('.s2-card')) return;
      this.querySelector('.s2-controls').hidden = false;
      this.querySelectorAll('[data-direction]').forEach(button => {
        button.addEventListener('click', () => {
          const step = track.querySelector('.s2-card').getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
          track.scrollBy({ left: Number(button.dataset.direction) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal: this.controller.signal });
      });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
